import { Search01Icon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const Search = /* @__PURE__ */ createIcon(Search01Icon, 'Search');
